/*cc sound framework
 *author: Jonathan 'JK' Kernick
 *description: an robust audiomanager that provides improved audio handling in mobile devices
 */

//if there is no CC 'namespace' then create one
if (typeof CC === "undefined") {
    var CC = {
        dummy: "dummy"
    };
    CC.isMobile = navigator.userAgent.match(/BlackBerry|IEMobile|Windows Phone|Android|iPad|iPhone|Silk|iPod|Kindle|Nexus/i) !== null;

}
CC.isNexus = navigator.userAgent.match(/Nexus/i) !== null;
CC.isKindle = navigator.userAgent.match(/Silk|Kindle/i) !== null;
CC.isNotIOS = navigator.userAgent.match(/iPhone|iPod|iPad/i) === null;
CC.isBookTrust = navigator.userAgent.match(/Android/i) !== null && navigator.userAgent.match(/Chrome/i) !== null;
/*
 #####
 #     #   ####   #    #   ####   #####  #####   #    #   ####   #####   ####   #####
 #        #    #  ##   #  #         #    #    #  #    #  #    #    #    #    #  #    #
 #        #    #  # #  #   ####     #    #    #  #    #  #         #    #    #  #    #
 #        #    #  #  # #       #    #    #####   #    #  #         #    #    #  #####
 #     #  #    #  #   ##  #    #    #    #   #   #    #  #    #    #    #    #  #   #
 #####    ####   #    #   ####     #    #    #   ####    ####     #     ####   #    #

 */

//cc sound constructor
CC.Sound = function(audioData) {
    //sets up the sound, should this already be done it will be ignored!
    CC.Sound._setUpCCSound();
    //finds a valid url from the audio data urls
    this._url = CC.Sound._findValidUrl(audioData.urls || audioData.src);
//assigns over the sprite value if there is any
    if(audioData.sprite !== undefined)
    {
        this._sprites = audioData.sprite;
    }
    //assigns over the sprite value if there is any
    if(audioData.sprites !== undefined)
    {
        this._sprites = audioData.sprites;
    }
    //duplicates reffrences for compatablity
    this._sprite = this._sprites;
    this._src = this._url;
    //if they are in milliseconds devide all the sprites times by 1000
    if(audioData.milliseconds)
    {
        for(var key in this._sprites)
        {
            this._sprites[key][0] *= 0.001;
            this._sprites[key][1] *= 0.001;
        }
    }
    //
    if(audioData.endTimes)
    {
        for(var key in this._sprites)
        {
            this._sprites[key][1] -= this._sprites[key][0];
        }
    }
    //assigns over the loopin' bool
    if (audioData.looping !== undefined) {
        this._looping = audioData.looping;
    }
    //assigns over the auto play bool
    if (audioData.autoPlay !== undefined) {
        this._autoPlay = audioData.autoPlay;
    }
    //assigns callback
    this.callBackCalled = false;
    this.soundLoadedCallback = function() {
        if(window.soundLoaded)
        {
            window.soundLoaded();
        }

    };
    //now we do differnt things if web audio is suported or if it is not
    if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
        //web audio api is suported
        this._preLoadWebAudio(this._url);
    } else {
        //web audio api is not suported fallback to html5 aduio
        //because of scope we have to put this in so i can reffrence it inside the ananomnus functions i am creating
        var self = this;
        //creates the audio object this is the all important point
        this._audioHtml = new Audio(this._url);
        //this._audioHtml = document.createElement("audio");
        //this._audioHtml.src = this._url;


        this._audioHtml.addEventListener('loadstart',
            function() {
                //console.log("loadstart");
            },
            false
        );
        this._audioHtml.addEventListener('durationchange',
            function() {
                //console.log("durationchange");
            },
            false
        );
        this._audioHtml.addEventListener('loadedmetadata',
            function() {
                //console.log("loadedmetadata");
            },
            false
        );
        this._audioHtml.addEventListener('loadeddata',
            function() {
                //console.log("loadeddata");
            },
            false
        );
        //creates an event to let us know that the audio is ready to play
        this._audioHtml.addEventListener('progress',
            function() {
                //console.log("progress");
            },
            false
        );
        this._audioHtml.addEventListener('canplay',
            function() {
                //console.log("canplay");
            },
            false
        );
        this._audioHtml.addEventListener('canplaythrough',
            function() {
                //console.log("canplaythrough");
                //huhzar the audio is loaded, set the load flag
                if (!self.callBackCalled) {
                    self.soundLoadedCallback();
                }
                self.callBackCalled = true;
                self._loaded = true;
                self._onload();
            },
            false
        );
        this._audioHtml.addEventListener('error',
            function() {
                //console.log("error: " + event);
            },
            false
        );

        /*
         #        #######  #######  ######
         #        #     #  #     #  #     #
         #        #     #  #     #  #     #
         #        #     #  #     #  ######
         #        #     #  #     #  #
         #        #     #  #     #  #
         #######  #######  #######  #

         */
        //this is the checker to make sure the audio is beahving correctly
        setInterval(function() {

            //code to track the progress of the audio sprite
            if (self._currentSprite !== null && self._currentSprite !== 'default') {
                self._intervals++;
                //if the play head is not in the correct position ie has fallen behind the start position
                var currentTime = (Number)(self._audioHtml.currentTime);
                //negates 1 second for safty
                if (currentTime < (Number)(self._currentSprite[0] - 1)) {
                    self._audioHtml.currentTime = self._currentSprite[0];
                    //console.log("reset")
                }
                //stop the clip if the play head has not played
                if (currentTime > (self._currentSprite[0] + self._currentSprite[1])) {
                    self.stop();
                    //self._audioHtml.pause();

                    //console.log("auto Stop")
                }
            } else {
                //console.log("stop")
                self.stop();
            }
        }, 100);

        /*
         #######   #####        #####
         #  #     #  #     #      #     #  #    #  ######   ####   #    #
         #  #     #  #            #        #    #  #       #    #  #   #
         #  #     #   #####       #        ######  #####   #       ####
         #  #     #        #      #        #    #  #       #       #  #
         #  #     #  #     #      #     #  #    #  #       #    #  #   #
         #  #######   #####        #####   #    #  ######   ####   #    #


         */
        //if it is an apple device we have to acomidate the
        //fact that they need a screen touch play for audio to be enabled
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Silk|Kindle)/i) !== null) {
            if (!self.callBackCalled) {
                self.soundLoadedCallback();
                self.callBackCalled = true;
            }
            //assigns a new function to a touch var
            var touchEvent = function(event) {
                var reloadInverval = setInterval(function() {
                    if (isNaN(self._audioHtml.duration)) {
                        self._audioHtml.load();
                    } else {
                        clearInterval(reloadInverval);
                    }
                }, 3000);
                //console.log('iOS first touch');
                //prevents any scrolling from this touch event
                event.preventDefault();
                //plays the audio from the start
                self._audioHtml.play();
                //any responcible audio sprite has 3 seconds of silence at the begining
                self._currentSprite = [0, 3];
                //remove the event since it is only required once.
                window.removeEventListener('touchstart', touchEvent, false);
            };
            //creates the one shot event
            window.addEventListener('touchstart', touchEvent, false);
        } else {
            //this._loaded = true;
            if(!CC.isKindle)
            {
                this._audioHtml.load();
            }
        }
    }
};
/*
 #####   #######  ######      #     #         #####
 #     #  #     #  #     #    # #    #        #     #
 #        #     #  #     #   #   #   #        #
 #  ####  #     #  ######   #     #  #         #####
 #     #  #     #  #     #  #######  #              #
 #     #  #     #  #     #  #     #  #        #     #
 #####   #######  ######   #     #  #######   #####

 */


//global var for audio context
CC.Sound._GLOBAL_AUDIO_CONTEXT = "unassigned";
//global var for mime type
CC.Sound._GLOBAL_MIME_TYPE = "unassigned";
//global var for exstention
CC.Sound._GLOBAL_EXSTENTIONS = [];
//global var for web audio suport
CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED = false;
//global var tracking if first time set up has been performed
CC.Sound._GLOBAL_SOUND_IS_NOT_SET_UP = true;



CC.Sound.exstentionsTypePairs = [{
    ext: ".m4a",
    mime: "audio/mp4"
}, {
    ext: ".mp4",
    mime: "audio/mp4"
}, {
    ext: ".aac",
    mime: "audio/aac"
}, {
    ext: ".ogg",
    mime: "audio/ogg"
}, {
    ext: ".mp3",
    mime: "audio/mpeg"
}];
CC.Sound.readyState = [
    "HAVE_NOTHING",
    "HAVE_METADATA",
    "HAVE_CURRENT_DATA",
    "HAVE_FUTURE_DATA",
    "HAVE_ENOUGH_DATA"
];
//checks for a suported soundType
CC.Sound._findValidUrl = function(urls) {
    //url var for returning the value
    var returnUrl = urls[0];
    //flick though the urls until you find a matching one starts from the back asuiming preferential order
    for (var i = urls.length - 1; i >= 0; --i) {
        //sets this var to the url we are inspecting
        var currentUrl = urls[i];
        //subs the actual exstention we are taking a leap in logic that there is an exstention at the end...
        var exstention = currentUrl.substring(currentUrl.length - 4, currentUrl.length);
        //now we go though each of the exstentions that is proably suported by this browser
        for (var j = 0; j < CC.Sound._GLOBAL_EXSTENTIONS.length; ++j) {
            //of the exstention matches the global exstentions then hot damn!
            if (exstention === CC.Sound._GLOBAL_EXSTENTIONS[j]) {
                //assigns the current url to the return url
                returnUrl = currentUrl;
            }
        }
    }
    //console.log("Selected url: \"" + returnUrl + "\"")
    return returnUrl;
};
/*
 #     #  #######  #######  #     #  #######  ######    #####
 ##   ##  #           #     #     #  #     #  #     #  #     #
 # # # #  #           #     #     #  #     #  #     #  #
 #  #  #  #####       #     #######  #     #  #     #   #####
 #     #  #           #     #     #  #     #  #     #        #
 #     #  #           #     #     #  #     #  #     #  #     #
 #     #  #######     #     #     #  #######  ######    #####

 */
//set up the prototype for the audio
CC.Sound.prototype = {
    //if web audio is enabled
    _webAudioEnabled: false,
    //is the mute current on
    _isMute: false,
    //chosen sound url string
    _url: "unassigned",
    //is the clip running hot ie not stopping when paused or stopped
    _isHot: false,
    //if the audio is currently playing
    _isPlaying: false,
    //if the audio is set to loop
    _looping: false,
    //if the audio is set to autoplay
    _autoPlay: false,
    //if the audio is currently stopped
    _isStopped: true,
    //if the audio is currently paused
    _isPaused: true,
    //if the audio has finshed loading
    _loaded: false,
    //if the audio is currently buffering
    _isBuffering: false,
    //if the audio is currently stroage of the html audio
    _audioHtml: null,
    //if the audio is currently stroage of the html audio
    _currentSprite: null,
    //if the audio is currently stroage of the html audio
    _queuedSprite: [0, 2],
    //storage object for the web audio api buffer
    _audioWebApi: null,
    //storage object for the sound Sprite Structure
    _activeSoundSources: [],
    //storage object for the sound Sprite Structure
    _sprites: null,
    //storage object for the sound Sprite Structure
    _spritesPlaying: {},
    //storage object for the sound Sprite Structure
    _intervals: 0,
    /*
     ######   #           #     #     #
     #     #  #          # #     #   #
     #     #  #         #   #     # #
     ######   #        #     #     #
     #        #        #######     #
     #        #        #     #     #
     #        #######  #     #     #


     */
    //play sound
    play: function(spriteString, noDuplicate, notNeeded,loop) {
        if (!notNeeded || !!CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
            //check if sound is already playing
            if (!this._sprites[spriteString]) {
                //console.log("sound: " + spriteString + " does not exist");
            }
            var playDuplicate = true;
            if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
                if (this._sprites !== null && this._sprites[spriteString] !== undefined && !this._spritesPlaying[spriteString]) {
                    playDuplicate = !(noDuplicate && !!this._spritesPlaying[spriteString]);
                }
            }

            //if the sound is loaded and sound is not muted then go right ahead
            if (this._loaded && !this._isMute && playDuplicate && this._sprites[spriteString] !== undefined) {
                //if(!!noDuplicate){this.stop(spriteString);}
                //console.log("Playing: \'"+spriteString+ "\'");
                //we are going to asume that start is the begining
                var startSeconds = 0;
                //the duration is set to negative 1 so i can be ignored if none is set
                var durationSeconds = -1;
                this._loopMode = !!loop;
                //if there is a sprite then check it
                //if this sprite actual exists in the sprite then continue
                if (this._sprites !== null && this._sprites[spriteString] !== undefined) {
                    //assigns the sprite values
                    startSeconds = this._sprites[spriteString][0];
                    durationSeconds = this._sprites[spriteString][1];

                }

                //now we do differnt things if web audio is suported or if it is not
                if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
                    //web audio api is suported

                    //once the audio is decoded wire up the audio
                    var source = CC.Sound._GLOBAL_AUDIO_CONTEXT.createBufferSource();
                    source.buffer = this._audioWebApi;
                    source.connect(CC.Sound._GLOBAL_AUDIO_CONTEXT.destination);
                    source.soundName = spriteString;
                    this._spritesPlaying[spriteString] = true;
                    this._activeSoundSources.push(source);
                    var self = this;
                    //console.log(source);
                    source.onended = function(value) {
                        var targetSrc = value.target;
                        //console.log('sound function has ended!!');
                        //console.log(value);
                        for (var i = 0; i < self._activeSoundSources.length; ++i) {
                            if (targetSrc === self._activeSoundSources[i]) {
                                self.onComplete(targetSrc.soundName);
                                //console.log(targetSrc.soundName + ' : has ended!');
                                self._spritesPlaying[targetSrc.soundName] = false;
                                self._activeSoundSources.splice(i, 1);
                            }
                        }
                    };
                    //plays the sound acording to the sound sprite
                    //checks to see if the source.start is avalable if it is then it starts it
                    //if not it used the old noteGrainOn
                    if (source.start) {
                        source.start(0, startSeconds, durationSeconds);
                    } else {
                        source.noteGrainOn(0, startSeconds, durationSeconds);
                    }
                } else {
                    //web audio api is not suported fallback to html5 audio

                    //ok lets start with the default current sprite this is incase we have 'NO_SPRITE'
                    this._currentSprite = 'NO_SPRITE';
                    if (this._sprites !== undefined && this._sprites[spriteString] !== undefined) {
                        this._currentSprite = this._sprites[spriteString];
                    }
                    //sets the star time to the current sprite time
                    this._audioHtml.currentTime = this._currentSprite[0];
                    this._audioHtml.play();
                }
            }
            return(this._sprites[spriteString]);
        }
    },
    onComplete: function() {},
    //reloads html5 sound
    reload: function() {
        //if the not web audio then run the reset
        if (!CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
            //first sets the mute to true
            this._audioHtml.load();
        }

    },
    //unmutes sound
    unmute: function() {
        //if muted then run code
        if (this._isMute) {
            //first sets the mute to true
            this._isMute = false;
        }

    },
    //mutes sound
    mute: function() {
        //if muted then run code
        if (!this._isMute) {
            //first sets the mute to true
            this._isMute = true;
            this.stop();

        }

    },
    _onloadCalled: false,

    _onload: function() {
        this._onloadCalled = true;
        var that = this;
        setTimeout(function() {
            that.onload();
        }, 1000);

    },

    onload: function() {

    },
    //play sound
    pos: function() {
        var returnPos = -1;
        if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
            //web audio api is suported
            returnPos = -2;
            returnPos = 0;//CC.Sound._GLOBAL_AUDIO_CONTEXT.currentTime;

        } else {
            //web audio api is not suported fallback to html5 audio
            returnPos = -3;
            returnPos = this._audioHtml.currentTime;
        }
        return returnPos;
    },
    /*
     #####   #######  #######  ######
     #     #     #     #     #  #     #
     #           #     #     #  #     #
     #####      #     #     #  ######
     #     #     #     #  #
     #     #     #     #     #  #
     #####      #     #######  #

     */
    //stop sound all sound
    stop: function() {
        this._loopMode = false;
        var self = this;
        if (this._loaded) {
            //this._currentSprite = null;
            if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
                //web audio api is suported
                //stops the sound source if needed
                //var stopSpriteNames = stopSpesificSprite = (spriteString && this._sprites !== null && this._sprites[spriteString] !== undefined);

                //we need a copy of the length while the array is untainted
                var length = this._activeSoundSources.length;

                //and now we must destory each source one after the other
                for (var i = 0; i < length; ++i) {
                    //right lets pop this off the top and give it a good ringing
                    var currentSource = this._activeSoundSources.pop();
                    //checks if stop is avalable if it is use it if not then use noteOff
                    if (currentSource.stop) {
                        currentSource.stop(0);
                    } else {
                        currentSource.noteOff(0);
                    }
                }


            } else {
                //web audio api is not suported fallback to html5 audio
                this._audioHtml.pause();
                //nulls the sprite so it will be ignored
                self._currentSprite = null;
            }
        }
    },
    stopSound:function(name){
        if (this._loaded) {
            if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
                var length = this._activeSoundSources.length;

                //and now we must destory each source one after the other
                for (var i = 0; i < length; ++i) {
                    var currentSource = this._activeSoundSources[i];
                    if(currentSource.soundName == name){
                        if (currentSource.stop) {
                            currentSource.stop(0);
                        } else {
                            currentSource.noteOff(0);
                        }
                        this._activeSoundSources.splice(i,1);
                        break;
                    }
                }
            } else {
                // console.log("not possible to stop individual sound")
            }
        }
    },
    //pauses sound all sound
    pause: function() {
        if (this._loaded) {
            if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
                //web audio api is suported

                //noting can happen because it lacks this functionality

            } else {
                //web audio api is not suported fallback to html5 audio
                this._audioHtml.pause();
            }
        }
    },
    /*
     ######   ######   #######  #        #######     #     ######
     #     #  #     #  #        #        #     #    # #    #     #
     #     #  #     #  #        #        #     #   #   #   #     #
     ######   ######   #####    #        #     #  #     #  #     #
     #        #   #    #        #        #     #  #######  #     #
     #        #    #   #        #        #     #  #     #  #     #
     #        #     #  #######  #######  #######  #     #  ######

     */
    _preLoadWebAudio: function(url) {
        //console.log("Preloading: \'"+url+"\'");
        //url for returning the value
        var request = new XMLHttpRequest();
        //opens the request
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';
        var self = this;
        // Decode asynchronously
        request.onload = function() {
            CC.Sound._GLOBAL_AUDIO_CONTEXT.decodeAudioData(request.response, function(buffer) {
                self._audioWebApi = buffer;
                if (navigator.userAgent.match(/(iPhone|iPod|iPad|Silk|Kindle)/) !== null) {
                    if (!self.callBackCalled) {
                        self.soundLoadedCallback();
                        self.callBackCalled = true;
                    }
                    var touchEvent = function() {
                        //console.log("first touch")
                        var source = CC.Sound._GLOBAL_AUDIO_CONTEXT.createBufferSource();
                        source.buffer = buffer;
                        source.connect(CC.Sound._GLOBAL_AUDIO_CONTEXT.destination);
                        //plays the sound acording to the sound sprite
                        if (source.start) {
                            source.start(0, self._queuedSprite[0], self._queuedSprite[1]);
                        } else {
                            source.noteGrainOn(0, self._queuedSprite[0], self._queuedSprite[1]);
                        }

                        self._loaded = true;
                        self._onload();
                        //removes event of one shout touch
                        window.removeEventListener('touchstart', touchEvent, false);
                    };
                    //creates one shot touch event for ios considerations
                    window.addEventListener('touchstart', touchEvent, false);

                } else {
                    self._loaded = true;
                    self._onload();
                    if (!self.callBackCalled) {
                        self.soundLoadedCallback();
                        self.callBackCalled = true;
                    }
                }
            }, function() {});
        };
        request.send();
    },
};
//anommuns function for finding the suported audio type and assigning web audio
CC.Sound._setUpCCSound = function() {
    if (CC.Sound._GLOBAL_SOUND_IS_NOT_SET_UP) {
        //console.log("Setting up sound");
        CC.Sound._GLOBAL_SOUND_IS_NOT_SET_UP = true;
        //checks is web audio is suported
        CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED = /*(navigator.userAgent.match(/FireFox/i) === null) &&*/ (!!(window.AudioContext || window.webkitAudioContext));
        //delete this after test
        //CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED = false;
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Silk|Kindle)/) === null && CC.isMobile) {
            //CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED = false;
        }
        if(CC.isNexus || CC.isKindle)
        {
            //CC.Sound._GLOBAL_EXSTENTIONS.push(".ogg");
            //CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED = false;
        }
        if (CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED) {
            //consolidates web audio context into one var
            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            CC.Sound._GLOBAL_AUDIO_CONTEXT = new AudioContext();
        }
        //creates test audio object for checking playability
        var testAudio = document.createElement("audio");
        for (var i = 0; i < CC.Sound.exstentionsTypePairs.length; ++i) {
            //asigns the mime type pair to audio
            var testPair = CC.Sound.exstentionsTypePairs[i];
            //check audio suport
            var result = testAudio.canPlayType(testPair.mime);
            if (result === "probably") {
                //if suported use this exstention
                CC.Sound._GLOBAL_EXSTENTIONS.push(testPair.ext);
                //console.log("Mime Match: " +CC.Sound.exstentionsTypePairs[i].ext + " : " +result);
            }
        }
        //if no "probably"'s came up then check for mabeys
        if(CC.Sound._GLOBAL_EXSTENTIONS.length === 0)
        {
            for (var i = 0; i < CC.Sound.exstentionsTypePairs.length; ++i) {
                //asigns the mime type pair to audio
                var testPair = CC.Sound.exstentionsTypePairs[i];
                //check audio suport
                var result = testAudio.canPlayType(testPair.mime);
                if (result === "maybe") {
                    //if suported use this exstention
                    CC.Sound._GLOBAL_EXSTENTIONS.push(testPair.ext);
                    //console.log("Mime Match: " +CC.Sound.exstentionsTypePairs[i].ext + " : " +result);
                }
            }
        }
    }
};